import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { FastOmit } from 'styled-components/dist/types';

interface PercentCircleProps{
    label:string,
    percent:number
}

const PercentCircle = ({label, percent}:PercentCircleProps) => {
    const circle = useRef<HTMLDivElement>(null);
	const per = percent * 3.6;
    
    useEffect(() => {
        if(circle.current !== null){
            circle.current.style.background = `conic-gradient(rgba(255, 255, 255, 0.7) ${per}deg, rgba(255, 255, 255, 0) ${per}deg)`;
        }
       // eslint-disable-next-line
    },[percent])

	return (
		<DonutContainer ref={circle}>
            <DonutInner>
                <Label>{label}</Label>
                <Percent >{`${Math.floor(percent)}%`}</Percent>
            </DonutInner>
        </DonutContainer>
	);
};

const DonutContainer = styled.div`
    width: 200px; /* 부모 요소의 너비에 따라 도넛의 크기가 조절됨 */
    height: 200px; /* 부모 요소의 높이에 따라 도넛의 크기가 조절됨 */
    display: flex;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    background: conic-gradient(rgba(255, 255, 255, 0.7) 0deg, rgba(255, 255, 255, 0) 0deg);
    transition: 1s;
    align-items: center;
`;



const DonutInner = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 180px; /* 안쪽 원의 너비 */
    height: 180px; /* 안쪽 원의 높이 */
    background: linear-gradient(270deg, #FFF -123.52%, #DF0000 99.99%), #DF0000; /* 배경색을 흰색으로 설정하여 안쪽을 비움 */
    border-radius: 50%; /* 안쪽 원을 만들기 위해 반지름 50% 설정 */
`;

const Label = styled.span`
    color: #FFF;
    font-size: 20px;
    font-weight: 500;
`

const Percent = styled.span`
    color: #FFF;
    font-size: 30px;
    font-weight: 600;
`

export default PercentCircle
